import React, {useState, useEffect} from "react";

function TextArea(props) {
    const [remainingCharacters, setRemainingCharacters] = useState(props.maxLength)
    
    useEffect(() => {
        setRemainingCharacters(props.maxLength - props.value.length);
    }, [props.value])
    
    return (
        <div className="text-area-container">
            <textarea style={{flex: "1 1 0"}} value={props.value} maxLength={props.maxLength} onChange={(event) => props.onChange(event)}/>
            <p className="text-area-blob">
                <strong>Note:</strong>
                <span> Max character length {props.maxLength}</span>
                <span style={{float: "right"}}>Remaining Characters: {remainingCharacters}</span>
            </p>
        </div>
    )
}

export default TextArea;